module.exports = __webpack_public_path__ + "static/media/github.c2e14805.png";